<script setup lang="ts">
import MainBreadcrumbs from "../../../ui/components/header/MainBreadcrumbs.vue";
import Card from "../../../ui/components/cards/Card.vue";
import { onBeforeMount, ref, Ref } from "vue";
import { useApiClient } from "@/api/client";
import { useRoute } from "vue-router";
import { RouteGuards } from "@/router/guards";
import { useBaseStore } from "@/stores/base";
import UserDO = App.Data.UserDO;
const store = useBaseStore();

const user: Ref<UserDO | undefined> = ref();

const breadcrumbs = ref([
	{
		title: "Users",
		disabled: false,
		to: "/users",
	},
]);

const tabs: Ref<tabsType[]> = ref([]);

const loadUser = async () => {
	const uuid: string | string[] = useRoute().params.uuid ?? "";
	const response = await useApiClient("users").getUserByUUID(uuid);
	if (response.isOk()) {
		user.value = response.value;

		breadcrumbs.value.push({
			title: response.value.name,
			disabled: true,
			to: "",
		});

		tabs.value = [
			{
				itemId: "general-settings",
				translationKey: "users.detail.generalTab",
				icon: "fa-user-astronaut",
				to: `/users/edit/${response.value.uuid}/general-settings`,
			},
			{
				itemId: "notification-events",
				translationKey: "users.detail.notificationsTab",
				icon: "fa-bell-on",
				to: `/users/edit/${response.value.uuid}/notification-events`,
			},
			{
				itemId: "notification-settings",
				translationKey: "users.detail.notificationPreferenceTab",
				icon: "fa-list-check",
				to: `/users/edit/${response.value.uuid}/notification-preference`,
			},
			{
				itemId: "api-tokens",
				translationKey: "users.detail.apiTokensTab",
				icon: "fa-arrow-down-up-lock",
				to: `/users/edit/${response.value.uuid}/api-tokens`,
			},
			{
				itemId: "permissions",
				translationKey: "users.detail.permissionTab",
				icon: "fa-list-check",
				to: `/users/edit/${response.value.uuid}/permissions`,
			},
		];
	}
};

onBeforeMount(async () => {
	await loadUser();
});

type tabsType = {
	itemId: string;
	translationKey: string;
	icon: string;
	to: string;
};

const updateUser = (updatedUser: App.Data.UserDO) => {
	console.log("user-updated");
	user.value = updatedUser;
};

const activeTab = ref(null);
</script>

<template>
	<main-breadcrumbs
		:breadcrumbs="breadcrumbs"
		v-if="user"
		:key="user.name ?? 0"
	/>
	<v-tabs v-model="activeTab">
		<v-tab
			v-for="tab in tabs"
			v-show="
				RouteGuards.hasPermissions({
					to: RouteGuards.getRouteByPath(tab.to),
					store,
				})
			"
			:value="tab.itemId"
			color="primary"
			:to="tab.to"
		>
			<i :class="`fa-duotone ${tab.icon} fa-lg`"></i>
			<div class="tab-text">
				{{ $t(tab.translationKey) }}
			</div>
		</v-tab>
	</v-tabs>
	<v-divider />
	<v-card-text class="pa-0">
		<router-view :user="user" @update-user="updateUser" />
	</v-card-text>
</template>

<style lang="scss"></style>
